'use strict';

var _createForOfIteratorHelper = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/zl22222222/myagent/_work/5/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var RTFGroup = require('./rtf-group.js');

var RTFParagraph = require('./rtf-paragraph.js');

var RTFDocument = /*#__PURE__*/function (_RTFGroup) {
  _inherits(RTFDocument, _RTFGroup);

  var _super = _createSuper(RTFDocument);

  function RTFDocument() {
    var _this;

    _classCallCheck(this, RTFDocument);

    _this = _super.call(this);
    _this.charset = 'ASCII';
    _this.ignorable = false;
    _this.marginLeft = 1800;
    _this.marginRight = 1800;
    _this.marginBottom = 1440;
    _this.marginTop = 1440;
    _this.style = {
      font: 0,
      fontSize: 24,
      bold: false,
      italic: false,
      underline: false,
      strikethrough: false,
      foreground: null,
      background: null,
      firstLineIndent: 0,
      indent: 0,
      align: 'left',
      valign: 'normal'
    };
    return _this;
  }

  _createClass(RTFDocument, [{
    key: "get",
    value: function get(name) {
      return this[name];
    }
  }, {
    key: "getFont",
    value: function getFont(num) {
      return this.fonts[num];
    }
  }, {
    key: "getColor",
    value: function getColor(num) {
      return this.colors[num];
    }
  }, {
    key: "getStyle",
    value: function getStyle(name) {
      if (!name) return this.style;
      return this.style[name];
    }
  }, {
    key: "addContent",
    value: function addContent(node) {
      if (node instanceof RTFParagraph) {
        while (this.content.length && !(this.content[this.content.length - 1] instanceof RTFParagraph)) {
          node.content.unshift(this.content.pop());
        }

        _get(_getPrototypeOf(RTFDocument.prototype), "addContent", this).call(this, node);

        if (node.content.length) {
          var initialStyle = node.content[0].style;
          var style = {};
          style.font = this.getFont(initialStyle.font);
          style.foreground = this.getColor(initialStyle.foreground);
          style.background = this.getColor(initialStyle.background);

          for (var _i = 0, _Object$keys = Object.keys(initialStyle); _i < _Object$keys.length; _i++) {
            var prop = _Object$keys[_i];
            if (initialStyle[prop] == null) continue;
            var match = true;

            var _iterator = _createForOfIteratorHelper(node.content),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var span = _step.value;

                if (initialStyle[prop] !== span.style[prop]) {
                  match = false;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (match) style[prop] = initialStyle[prop];
          }

          node.style = style;
        }
      } else {
        _get(_getPrototypeOf(RTFDocument.prototype), "addContent", this).call(this, node);
      }
    }
  }]);

  return RTFDocument;
}(RTFGroup);

module.exports = RTFDocument;